import type { ElementType, ReactNode } from "react";

import { cn } from "@/lib/utils";

interface BrandNameProps {
  as?: ElementType;
  className?: string;
  children?: ReactNode;
}

export function BrandName({
  as: Component = "span",
  className,
  children = "Fluxus",
}: BrandNameProps) {
  return <Component className={cn("font-brand", className)}>{children}</Component>;
}
